export default (data) => {
    return `<ul class="popup__list">
            ${data.join('')}
        </ul>`;
}